/**
 * The app global state selectors
 */

import { createSelector } from "reselect";

const selectGlobal = state => state.get("app");

const makeSelectCurrentSite = () =>
  createSelector(selectGlobal, globalState => globalState.get("site"));

const makeSelectCurrentUser = () =>
  createSelector(selectGlobal, globalState => globalState.get("currentUser"));

const makeSelectCurrentUserToken = () =>
  createSelector(selectGlobal, userState => userState.getIn(["currentUser", "token"]));

export {
  selectGlobal,
  makeSelectCurrentSite,
  makeSelectCurrentUser,
  makeSelectCurrentUserToken
};
